import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-additional-values',
  standalone: true,
  templateUrl: './additional-values.component.html',
  styleUrls: ['./additional-values.component.scss'],
  imports: [CommonModule, MatTooltipModule],
})
export class AdditionalValuesComponent {
  @Input() public additionalValues: string[] = [];
  @Input() public includePaddingInMinWidth = false; // We need this to ensure that the badge is circular, we had issues with this in the prime table and outside it

  public getAdditionalValuesTooltip(): string {
    return this.additionalValues.join(', ');
  }
}
